import React from 'react';
import PropTypes from 'prop-types';
import { default as MuiListItemSecondaryAction } from '@mui/material/ListItemSecondaryAction';

/**
 * A simple wrapper component to apply secondary action styles to ListItems.
 */
var ListItemSecondaryAction = function ListItemSecondaryAction(props) {
  return /*#__PURE__*/React.createElement(MuiListItemSecondaryAction, props);
};
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
ListItemSecondaryAction.propTypes = {
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
};
export default ListItemSecondaryAction;